import React,{Component} from 'react';
import "./Devices.css";

export default class Devices extends Component { 

render(){
    return(
        <div className="page-pad">
            <h2>Assets</h2>
            <p>Coming in v2.11</p>
        </div>
    )};
}
